import { getCurrentTenant } from "./tenantConfig";

const tenant = getCurrentTenant();

const KEYCLOAK_CONFIG = {
  realmUrl: `${tenant?.keycloakHost}/realms/${tenant?.projectCode}`,
  clientId: "DefaultClient",
  redirectUri: window.location.origin + "/login",
  silentRedirectUri: window.location.origin + "/silent-auth.html",
};

export default KEYCLOAK_CONFIG;
